import { ChangeEvent, FC, KeyboardEvent, useEffect, useState } from 'react';

import { Stack, TextField, Typography } from '@thirdspacelearning/library';

type Props = {
    name: string;
    label: string;
    value: string;
    onSubmit: (name: string, value: string) => void;
};

const InputField: FC<Props> = ({ name, label, value, onSubmit }) => {
    const [currentText, setCurrentText] = useState(value);

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        setCurrentText(e.target.value);
    };

    const onInputEnter = (e: KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.currentTarget.blur();

            onSubmit(name, currentText);
        }
    };

    useEffect(() => {
        setCurrentText(value ?? '');
    }, [value]);

    return (
        <Stack>
            <Typography
                variant="caption"
                fontWeight="SemiBold"
                color="grey.700"
                data-testid={`filter-${name}`}
            >
                {label}
            </Typography>
            <TextField
                variant={'outlined'}
                size="small"
                value={currentText}
                onChange={onChange}
                onKeyDown={onInputEnter}
                placeholder={`Search by ${label}...`}
                inputProps={{ 'aria-label': `search-${name}` }}
                sx={{
                    '&.MuiFormControl-root': { m: 0, width: '200px' },
                }}
            />
        </Stack>
    );
};

export default InputField;
